import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  AfterViewInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderComponent implements OnDestroy, OnInit, AfterViewInit {
  userName: string = '';
  userInitials: string = '';
  @ViewChild('neptuneHeader') neptuneHeaderRef!: ElementRef;
  @Output() emitOption = new EventEmitter<any>();
  authenticationService = inject(AuthenticationService);

  private readonly headerItemHandler: EventListener = (event: Event) => {
    const customEvent = event as CustomEvent;
    if (customEvent.detail?.item?.id === 'logout') {
      this.emitOption.emit();
    }
  };

  ngOnInit() {
    this.userName = this.authenticationService.getLoggedInUserName();
    this.userInitials = this.userName
      .split(' ')
      .map((n) => n.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  }

  ngAfterViewInit() {
    const neptuneHeaderElement = this.neptuneHeaderRef.nativeElement;
    neptuneHeaderElement.headerActionItems = {
      profile: [{ name: 'Log Out', id: 'logout' }],
    };
    neptuneHeaderElement.addEventListener(
      'header-item-selected',
      this.headerItemHandler,
    );
  }

  ngOnDestroy() {
    if (this.neptuneHeaderRef?.nativeElement) {
      this.neptuneHeaderRef.nativeElement.removeEventListener(
        'header-item-selected',
        this.headerItemHandler,
      );
    }
  }
}
